import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';

import { useForm } from '../../presentation/hooks/useForm';
import { useTurnstile } from '../../presentation/hooks/useTurnstile';
import { useCaptchaVerification } from '../../presentation/hooks/useCaptchaVerification';

import { UIActions } from '../../presentation/redux/actions/UIActions';

import { recoveryPassword } from '../action/recoveryPassword';

import { LoadingScreen } from '../Layout/LoadingScreen';

import logo from './logo-final.svg';
import './login.css';

export const PassRecovery = () => {
  const dispatch = useDispatch();
  const { isLoadingActive } = useSelector(state => state.uiState);
  const [message, setMessage] = useState(null);
  const [mailRecovery, setMailRecovery] = useState('');
  const [formValues, handleInputChange] = useForm({
    pointOfSaleToRecovery: ''
  });
  const { pointOfSaleToRecovery } = formValues;

  // Usar el custom hook para Turnstile
  const {
    isScriptLoaded,
    captchaToken,
    btnDisabled,
    resetCaptcha
  } = useTurnstile();

  // Usar el hook para verificación
  const { verifyCaptcha } = useCaptchaVerification(setMessage, dispatch);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isScriptLoaded) {
      setMessage("El CAPTCHA no ha terminado de cargar.");
      return;
    }

    dispatch(UIActions.uiLoadActive());

    const verificationSuccess = await verifyCaptcha(captchaToken, resetPassword, resetCaptcha);

    if (!verificationSuccess) {
      dispatch(UIActions.uiLoadInactive());
    }
  }

  const resetPassword = () => {
    if (isFormValid()) {
      dispatch(UIActions.uiLoadActive());
      recoveryPassword(pointOfSaleToRecovery.trim(), setMailRecovery, dispatch);
    }
  }

  const isFormValid = () => {
    if (pointOfSaleToRecovery.trim().length === 0) {
      setMessage('Ingresa Punto de Venta')
      return false;
    }
    return true;
  }

  return (
    <>
      {isLoadingActive && <LoadingScreen />}
      <div className="login-container justify-content-center align-items-center d-flex flex-column body-gradient"
        style={{ top: '0px', bottom: '0px', left: '0px', right: '0px', position: 'fixed' }}>
        <div className="miclase col-lg-4 col-md-6 col-sm-12 bg-white shadow p-3">
          <form>
            {message &&
              <Alert variant="warning" onClose={() => setMessage(null)} dismissible>
                {message}
              </Alert>
            }
            <div className="row justify-content-center p-3">
              <img style={{ width: `12rem` }} src={logo} alt="logo redsmart" />
            </div>
            <div className="login-pdv text-center justify-content-center py-3">
              <h2><small>Restablecer contraseña</small></h2>
            </div>
            <div className="row justify-content-center py-3">
              <input
                type="text"
                className="col-10"
                autoComplete='off'
                name="pointOfSaleToRecovery"
                maxLength={9}
                onChange={handleInputChange}
                placeholder="Punto de Venta" />
            </div>
            <div className='text-center py-2'>
              <div
                id="my-turnstile-widget"
                style={{ minHeight: '65px' }}
              />
            </div>
            <div className="row justify-content-center py-3">
              {!mailRecovery ? (
                <button
                  id="recoverBtn"
                  type="submit"
                  className={`btn col-10 ${btnDisabled ? 'disabled' : ''}`}
                  disabled={btnDisabled}
                  onClick={handleSubmit}
                >
                  Recuperar Contraseña
                </button>
              ) : (
                <NavLink className="btn col-10" to="/login">
                  <button type="button" className="btn col-10">
                    Regresar a Login
                  </button>
                </NavLink>
              )}
            </div>
          </form>
          {mailRecovery && (
            <div className='px-4 text-center'>
              <p>Se acaba de enviar un correo electrónico a <strong>{mailRecovery}</strong> con un enlace para recuperar la contraseña</p>
            </div>
          )}
          <div className='text-center'>
            <NavLink to="/login">
              <small>Regresar a Login</small>
            </NavLink>
          </div>
        </div>
      </div>
    </>
  );
}